import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './Core/material.module';
import { LoginComponent } from './components/login/login.component';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RegisterComponent } from './components/register/register.component';
import { CoreModule } from './Core/core.module';
import { LoaderComponent } from './Core/components/loader/loader.component';
import { LoadingInterceptor } from './Core/interceptors/loader.interceptor';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { RetailerRegisterComponent } from './components/retailer-Register/retailer-Register.component';
import { ApproveUserComponent } from './components/approve-user/approve-user.component';
import { ToastInterceptor } from './Core/interceptors/toast.interceptor';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ApproveStoreCampaignComponent } from './components/approve-store-campaign/approve-store-campaign.component';
import { ApproveBusinessuserCampaignComponent } from './components/approve-businessuser/approve-business-user.component'; 
import { ServiceWorkerModule } from '@angular/service-worker';
import { OtpValidateComponent } from './components/otp-validate/otp-validate.component';
import { SafeUrlPipe } from './shared/pipes/safe-url.pipe';
import { QuillModule } from 'ngx-quill';
import { CrmHomeComponent } from './shared/crm-site/crm-home/crm-home.component';
import { CrmPriceComponent } from './shared/crm-site/crm-price/crm-price.component';
import { CrmTermsComponent } from './shared/crm-site/crm-terms/crm-terms.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { QRCodeModule } from 'angularx-qrcode';
import { CollectionComponent } from './components/collection/collection.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HighchartsChartModule } from 'highcharts-angular';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    RetailerRegisterComponent,
    ApproveUserComponent,
    ApproveStoreCampaignComponent,
    ApproveBusinessuserCampaignComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    LoaderComponent,
    OtpValidateComponent,  
    AnalyticsComponent,
    CollectionComponent,
    SafeUrlPipe,
    CrmHomeComponent,
    CrmPriceComponent,
    CrmTermsComponent,
  
    
  ],
  imports: [
    HighchartsChartModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    LayoutModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    CoreModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    QuillModule.forRoot(),
     QRCodeModule,
     DragDropModule,
    
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: ToastInterceptor, multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
